import { Navbar as BootstrapNavbar } from "react-bootstrap";
import Brand from "./Brand";
import Toggle from "./Toggle";
import Link from "../Nav/Link";
import Navbar from "./Navbar";

Navbar.Brand = Brand;
Navbar.Link = Link;
Navbar.Toggle = Toggle;
Navbar.Collapse = BootstrapNavbar.Collapse;

export default Navbar;
